import React, { useContext, useCallback } from 'react';

import { OverlayContextDispatch } from 'app/containers//contexts/overlay.context';
import { DishDetailsWithCustom } from '../DishDetailsWithCustom';
import { RENDERING_CONTEXT_DEFAULT } from '../const';


export const useDishDetails = (
    refetchCallback = () => { },
    onClose = () => { },
) => {
    const { pushOverlay, closeLastOverlays } = useContext(OverlayContextDispatch);

    const handleClose = useCallback(
        () => {
            closeLastOverlays();
            onClose();
        },
        [closeLastOverlays, onClose],
    );

    const openDishDetails = useCallback((
        id,
        renderingContext = RENDERING_CONTEXT_DEFAULT,
        detailsProps = {},
    ) => {
        pushOverlay({
            id: 'dish_details',
            template: 'bottom',
            overlayProps: { zIndex: 31000 },
            children: (
                <DishDetailsWithCustom
                    id={id}
                    renderingContext={renderingContext}
                    refetchCallback={refetchCallback}
                    onClose={handleClose}
                    {...detailsProps}
                />
            ),
        });
    }, [pushOverlay, handleClose, refetchCallback]);

    return { openDishDetails };
};
